import { UNMOUNT_SCREEN } from '../common/screen/screenActions';
import {
    SET_RCT_FLU_COMP_CONTENT, SHOW_QUESTION, HIDE_QUESTION,
    SHOW_SEGMENT, HIDE_SEGMENT, RESET_QUESTION_INDEX, UPDATE_QUESTION_INDEX,
    UPDATE_SELECTED_COMPREHENSION_RESPONSES, SET_IS_READY_SCRIPT_PLAYED,
    RESET_SELECTED_COMPREHENSION_RESPONSES,
} from './rctActions';

export const defaultState = {
    isDataFetched: false,
    activeSegmentIndex: undefined,
    isQuestionVisible: false,
    isSegmentVisible: false,
    passages: [],
    model: {},
    practice: {},
    selectedResponses: {},
    questionIndex: 0,
    isReadyScriptPlayed: false,
};

const formatSegments = (segments) => segments.map((segment) => ({
    text: segment.segment_text,
    id: segment.segment_idx,
}));

const formatQuestions = (fluencyItems) => fluencyItems.map((item) => ({
    id: item.segment_idx,
    stimulus: {
        text: item.question_text,
        id: item.item_id,
    },
    possibleResponses: item.possible_responses.map((answer) => ({
        text: answer.response_text,
        id: answer.response_id,
    })),
}));

const formatComprehensionItems = (comprehensionItems) => comprehensionItems.map((item) => ({
    id: item.item_id,
    stimulus: {
        audio: item.stimulus.question_audio,
        text: item.stimulus.question_text,
    },
    possibleResponses: item.possible_responses.map((answer) => ({
        responseLabel: answer.response_label,
        responseAudio: answer.response_audio,
        responseId: answer.response_id,
        responseText: answer.response_text,
    })),
}));

const rctFluCompReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_RCT_FLU_COMP_CONTENT:
        return {
            ...state,
            isDataFetched: true,
            formId: action.content.form_id,
            totalItems: {
                model: action.content.total_items.model,
                practice: action.content.total_items.practice,
                passages: action.content.total_items.passages,
            },
            model: {
                title: action.content.model[0].title,
                segments: formatSegments(action.content.model[0].segments),
                questions: formatQuestions(action.content.model[0].fluency_items),
            },
            practice: {
                title: action.content.practice[0].title,
                segments: formatSegments(action.content.practice[0].segments),
                questions: formatQuestions(action.content.practice[0].fluency_items),
            },
            passages: action.content.passages.map((passage) => ({
                title: passage.title,
                segments: formatSegments(passage.segments),
                questions: formatQuestions(passage.fluency_items),
                comprehensionItems: formatComprehensionItems(passage.comprehension_items),
            })),
        };
    case SHOW_SEGMENT:
        return {
            ...state,
            activeSegmentIndex: action.index,
            isSegmentVisible: true,
        };
    case HIDE_SEGMENT:
        return {
            ...state,
            isSegmentVisible: false,
        };
    case SHOW_QUESTION:
        return {
            ...state,
            isQuestionVisible: true,
        };
    case HIDE_QUESTION:
        return {
            ...state,
            isQuestionVisible: false,
        };
    case UPDATE_SELECTED_COMPREHENSION_RESPONSES:
        return {
            ...state,
            selectedResponses: {
                ...state.selectedResponses,
                [action.questionIndex]: action.responseIndex,
            },
        };
    case RESET_SELECTED_COMPREHENSION_RESPONSES:
        return {
            ...state,
            selectedResponses: {},
        };
    case UPDATE_QUESTION_INDEX:
        return {
            ...state,
            questionIndex: action.index,
        };
    case RESET_QUESTION_INDEX:
        return {
            ...state,
            questionIndex: 0,
        };
    case SET_IS_READY_SCRIPT_PLAYED:
        return {
            ...state,
            isReadyScriptPlayed: action.isPlayed,
        };
    case UNMOUNT_SCREEN:
        return {
            ...state,
            activeSegmentIndex: undefined,
            isQuestionVisible: false,
            isSegmentVisible: false,
            selectedResponses: {},
            questionIndex: 0,
        };
    default:
        return state;
    }
};

export default rctFluCompReducer;
